import { useNavigate } from 'react-router-dom';

export const NotFound = () => {
  
    window.location = "/";
  
  return <>
  
  </>
};